/* (c) Copyright Frontify Ltd., all rights reserved. */

import { MarkupElement } from '../../MarkupElement';

export class AlignJustifyMarkupElement extends MarkupElement {
    constructor(id = 'align-justify') {
        super(id);
    }
}
